import React from 'react';
import RepayLoanTestComponent from '../components/repay-loan1';

const RepayLoan1 = () => {
  return <RepayLoanTestComponent />;
};

export default RepayLoan1;
